module.exports = __webpack_public_path__ + "img/DAB.684975d9.png";